import MuiCarousel from 'react-material-ui-carousel';

const Carousel = (props) => {
    return <MuiCarousel {...props}>{props.children}</MuiCarousel>;
};

export default Carousel;
